import React, { useEffect, useState } from "react";
import useCourseStore from "../../store/useCourseStore";
import {
  Wrapper,
  DropdownContainer,
  SelectedText,
  DropdownIcon,
  DropdownList,
  DropdownItem,
} from "./styles";

const CourseDropDown = () => {
  const { courseItems, fetchCourseItems, selectedCourse, setSelectedCourse } =
    useCourseStore();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    fetchCourseItems();
  }, [fetchCourseItems]);

  const handleCourseSelect = (course) => {
    setSelectedCourse(course);
    setDropdownOpen(false);
  };

  return (
    <Wrapper>
      <DropdownContainer onClick={() => setDropdownOpen((v) => !v)}>
        <SelectedText title={selectedCourse}>{selectedCourse}</SelectedText>
        <DropdownIcon />
        <DropdownList isOpen={dropdownOpen}>
          {courseItems.map((course) => (
            <DropdownItem
              key={course}
              onClick={(e) => {
                e.stopPropagation(); 
                handleCourseSelect(course);
              }}
              title={course} 
            >
              {course}
            </DropdownItem>
          ))}
        </DropdownList>
      </DropdownContainer>
    </Wrapper>
  );
};

export default CourseDropDown;